export default __webpack_public_path__ + "static/media/forkifyProject.746ab49f.jpg";